/* eslint-disable no-unused-vars */
import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import Moment from "moment";
// import lodash from "lodash";
import "./Quotations.css";
import Navbar from "../core/components/NavBar";
import UserContext from "../core/UserContext";
import currencyFormatter from "currency-formatter";
import NoData from "../core/components/no-data/NoData";
// Axios
import {
  getPolicyClassName,
  getTotalPremiumWithAddOnValue,
  getUserDataFromLocalStorage,
} from "../core/utils";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

import { getLives } from "../quotation-view/QuotationView";
import UsePagination from "../core/components/usePagination";
import apiRoutes from "../api/apiRoutes";

const Quotations = () => {
  const [quotations, setQuotations] = useState();
  const [loading, setLoading] = useState(false);
  const [paginatedLimit, setPaginatedLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [columns, setColumns] = useState([
    {
      label: "Sum Assured",
      field: "initial_sum_assured",
    },
    {
      label: "Premium",
      field: "premium",
    },
    {
      label: "Payment Frequency",
      field: "payment_frequency",
    },
    {
      label: "Lives",
      field: "lives",
    },
    {
      label: "Term",
      field: "term",
    },
    {
      label: "Class of Policy",
      field: "class_of_policy",
    },
    {
      label: "Type",
      field: "type",
    },
    {
      label: "Created At",
      field: "created_at",
    },
    {
      label: "Is Forwarded",
      field: "is_forwarded",
    },
    {
      label: "Status",
      field: "expired_status",
    },
    {
      label: "",
      field: "view_details",
    },
  ]);
  const [rows, setRows] = useState([]);
  const { userData, setUserData } = useContext(UserContext);
  const userDataStorage = getUserDataFromLocalStorage();
  const axiosPrivate = useAxiosPrivate(userDataStorage);

  const data = () => {
    return {
      columns: [
        {
          label: "Name",
          field: "name",
          width: 150,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "Name",
          },
        },
        {
          label: "Position",
          field: "position",
          width: 270,
        },
        {
          label: "Office",
          field: "office",
          width: 200,
        },
        {
          label: "Age",
          field: "age",
          sort: "asc",
          width: 100,
        },
        {
          label: "Start date",
          field: "date",
          sort: "disabled",
          width: 150,
        },
        {
          label: "Salary",
          field: "salary",
          sort: "disabled",
          width: 100,
        },
      ],
      rows: [
        {
          name: "Tiger Nixon",
          position: "System Architect",
          office: "Edinburgh",
          age: "61",
          date: "2011/04/25",
          salary: "$320",
        },
        {
          name: "Garrett Winters",
          position: "Accountant",
          office: "Tokyo",
          age: "63",
          date: "2011/07/25",
          salary: "$170",
        },
        {
          name: "Ashton Cox",
          position: "Junior Technical Author",
          office: "San Francisco",
          age: "66",
          date: "2009/01/12",
          salary: "$86",
        },
      ],
    };
  };

  const fetchQuotations = useCallback(async () => {
    try {
      setLoading(true);
      const url = process.env.REACT_APP_API_URL + apiRoutes.initialQuotations;
      const response = await axiosPrivate.get(url);

      const sortedData = response.data.data.sort((a, b) =>
        b.createdAt.localeCompare(a.createdAt),
      );

      const sortedDataWithExpireFields = sortedData.map((_item) => {
        _item.quotationFormData = JSON.parse(_item.quotationFormData);
        const expiryDate = Moment(_item.createdAt).add(15, "days");
        _item.expired = expiryDate.diff(Moment(0, "HH")) <= 0;
        return _item;
      });

      setTotalItems(sortedDataWithExpireFields.length);
      setTotalPages(
        Math.ceil(sortedDataWithExpireFields.length / paginatedLimit),
      );

      setQuotations(sortedDataWithExpireFields);
      setLoading(false);
    } catch (error) {
      console.log({ error });
      setLoading(false);
    }
  }, [axiosPrivate, paginatedLimit]);

  const handlePageChange = useCallback((newPage) => {
    setCurrentPage(newPage);
  }, []);

  const handleLimitChange = useCallback((newLimit) => {
    setPaginatedLimit(Number(newLimit));
    setCurrentPage(1);
  }, []);

  const currentItems = useMemo(() => {
    if (!quotations) return [];
    const startIndex = (currentPage - 1) * paginatedLimit;
    const endIndex = startIndex + paginatedLimit;
    return quotations.slice(startIndex, endIndex);
  }, [quotations, currentPage, paginatedLimit]);

  useEffect(() => {
    fetchQuotations();
  }, [fetchQuotations]);

  return (
    <>
      <Navbar
        name={
          userData
            ? `${userData?.data?.firstname} ${userData?.data?.lastname}`
            : ""
        }
      />
      <div className="containerx tw-px-3 sm:tw-px-5 tw-w-full tw-mx-auto">
        {loading && (
          <>
            {/* <h4 className="mt-4">Quotations</h4> */}
            <div
              style={{ marginTop: 150 }}
              className="d-flex flex-column justify-content-center align-items-center"
            >
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div>Please wait...</div>
            </div>
          </>
        )}
        {quotations && quotations.length > 0 && (
          <div className="tw-w-full">
            <div
              className="mt-4 tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-gap-3 sm:tw-gap-4 p-3 sm:p-4 px-4 sm:px-5 text-white ila-bg"
              style={{ borderRadius: 2 }}
            >
              <h4 className="mb-0 tw-text-xl tw-font-semibold">
                My Term Assurance Quotes
              </h4>
              <a
                href={`${process.env.REACT_APP_BASENAME}/create-quotation`}
                className="btn ila-accent-btn text-white tw-whitespace-nowrap tw-text-sm sm:tw-text-base tw-w-full sm:tw-w-auto tw-text-center"
              >
                Create New Quotation
              </a>
            </div>

            <div className="tw-w-full tw-overflow-x-auto">
              <table className="table mt-5 tw-table-auto tw-whitespace-nowrap tw-min-w-full">
                <thead className="tw-font-bold tw-text-black">
                  <tr>
                    <th scope="col">Sum Assured</th>
                    <th scope="col">Premium</th>
                    <th scope="col">Payment Frequency</th>
                    <th scope="col">Lives</th>
                    <th scope="col">Term</th>
                    <th scope="col">Class of Policy</th>
                    <th scope="col">Type</th>
                    <th scope="col">Created At</th>
                    <th scope="col">Is Forwarded</th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody className="tw-text-black">
                  {currentItems.map((_quotation, index) => {
                    const initial_sum_assured = currencyFormatter.format(
                      parseFloat(
                        _quotation.quotationFormData.initial_sum_assured,
                      ),
                      { symbol: "Rs " },
                    );
                    const premium = currencyFormatter.format(
                      parseFloat(_quotation.premiumAmount),
                      { symbol: "Rs " },
                    );
                    const payment_frequency =
                      _quotation.quotationFormData.payment_insurance_plan;
                    const term =
                      _quotation.termNumber + " " + _quotation.termOption;
                    const class_of_policy = getPolicyClassName(
                      _quotation,
                      _quotation.quotationFormData.loan_plan,
                    );
                    const type = _quotation.quotationFormData.join_loan
                      ? "joint"
                      : "single";
                    const created_at = Moment(_quotation.createdAt).format(
                      "LLL",
                    );
                    const is_forwarded = _quotation.isForwardedToCustomer;
                    const expired_status = _quotation.expired;
                    const lives = getLives(_quotation);

                    return (
                      <tr key={_quotation.id || index}>
                        <td>{initial_sum_assured}</td>
                        <td>{premium}</td>
                        <td>{payment_frequency}</td>
                        <td>{lives}</td>
                        <td>{term}</td>
                        <td>{class_of_policy}</td>
                        <td className="tw-capitalize">{type}</td>
                        <td>{created_at}</td>
                        <td>
                          {is_forwarded ? (
                            <div className="badge bg-success">Yes</div>
                          ) : (
                            <div className="badge bg-danger">No</div>
                          )}
                        </td>
                        <td>
                          {expired_status ? (
                            <div className="badge bg-danger">Expired</div>
                          ) : (
                            <div className="badge bg-success">Active</div>
                          )}
                        </td>
                        <td>
                          {(!expired_status ||
                            _quotation.status !== "accepted") && (
                            <a
                              href={`${process.env.REACT_APP_BASENAME}/quotations/${_quotation.id}`}
                              className="btn btn-sm ila-action-link"
                            >
                              View
                            </a>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <UsePagination
              pgdrop="tw-hidden"
              limit={paginatedLimit}
              total={totalItems}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onLimitChange={handleLimitChange}
            />
          </div>
        )}

        {!loading && quotations && quotations.length === 0 && (
          <>
            <div
              className="mt-4 tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-gap-3 sm:tw-gap-4 p-3 sm:p-4 px-4 sm:px-5 text-white ila-bg"
              style={{ borderRadius: 2 }}
            >
              <h4 className="mb-0 tw-text-lg sm:tw-text-xl md:tw-text-2xl tw-font-semibold tw-whitespace-nowrap">
                My Term Assurance Quotes
              </h4>
              <a
                href={`${process.env.REACT_APP_BASENAME}/create-quotation`}
                className="btn ila-accent-btn text-white tw-whitespace-nowrap tw-text-sm sm:tw-text-base tw-w-full sm:tw-w-auto tw-text-center"
              >
                Create New Quotation
              </a>
            </div>
            <NoData />
          </>
        )}
      </div>
    </>
  );
};

export default Quotations;
